import * as actionTypes from "./actionTypes"


export const addAnimeStart=()=>{
    return {
        type:actionTypes.ADD_ANIME_START
    }
}
export const addAnimeSuccess=()=>{
    return {
        type:actionTypes.ADD_ANIME_SUCCESS
    }
}
export const addAnime=()=>{
    return dispatch=>{
    
        dispatch(addAnimeStart())
        if (addAnimeStart()){
           dispatch(addAnimeSuccess())
        }
    }
}




// WEBPACK FOOTER //
// ./src/store/action/addAnime.js